// extracted by mini-css-extract-plugin
var _1 = "ResponsiveImage_fallback__592b8";
var _2 = "ResponsiveImage_img__2d468";
var _3 = "ResponsiveImage_mask__b03d8";
export { _1 as "fallback", _2 as "img", _3 as "mask" }
